<template>
  <div v-if="shops && shops.length">
    <h2 class="page-container shop-city-page-title">{{ $t('site.shops.closest.store.title') }}</h2>
    <div class="page-container">
      <div v-if="$t('shops_attention_title')" class="shop-city-attention">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C21.9939 17.5203 17.5203 21.9939 12 22ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C19.995 7.58378 16.4162 4.00496 12 4ZM17 13H11V7H13V11H17V13Z" fill="#FFCE1F"/>
        </svg>
        <span class="shop-city-attention__title">{{ $t('shops_attention_title') }}</span>
        <span class="shop-city-attention__text">{{ $t('shops_attention_text') }}</span>
      </div>
    </div>
    <vue-map
      class="page-container page-container--shops-map"
      v-if="selectedUserLocation"
      :spots-list="filteredShops"
      :filtered-shops-by-city="filteredShopsByCity"
      without-list
    >
      <template v-slot:filters>
        <ShopsFilter v-if="!isShowFiltersModal" hot-update-filters filter-by-services />
      </template>
      <template v-slot:toggle-filters>
        <button @click="$modal.show('shops-filter-modal')" class="shop-city-toggle-filters-modal">
          <svg width="16"
               height="16"
               viewBox="0 0 16 16"
               fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path
              d="M4.66634 14H3.33301V12.6667H1.33301V11.3333H3.33301V10H4.66634V14ZM14.6663 12.6667H5.99967V11.3333H14.6663V12.6667ZM11.333 10H9.99967V8.66667H1.33301V7.33333H9.99967V6.008H11.333V10ZM14.6663 8.66667H12.6663V7.33333H14.6663V8.66667ZM7.33301 6H5.99967V4.66667H1.33301V3.33333H5.99967V2H7.33301V6ZM14.6663 4.66667H8.66634V3.33333H14.6663V4.66667Z"
              fill="#909090"
            />
          </svg>
          {{ $t('shops_filters_toggle_btn_tet') }}
        </button>
      </template>
    </vue-map>
    <div
      v-if="selectedCityOnShops && filteredShopsByCity && filteredShopsByCity.length && isFiltering"
      class="shops-filtered page-container page-container--rendered-blocks"
    >
      <ShopsSlider :shops="filteredShopsByCity" title="Фирменные магазины" />
    </div>
    <div class="shops-events">
      <EventsBlock :city-ids="[selectedCityOnShops.city_id]" />
    </div>
    <div class="shop-city page-container">
      <div class="shop-city__header">
        <h1 class="firm-shops__title">{{ $t('site.shops.page.h1') }}</h1>
      </div>
      <ul class="shop-city__list">
        <li
          class="shop-city__item"
          :class="{ 'shop-city__item--opened': openedCities[city] }"
          v-for="(shops, city) in computedShopsByCities"
          :key="city"
        >
          <div class="shop-city__item-header" @click="toggleOpenedCity(city)">
            <div class="shop-city__item-shop-name">
              {{ city }}
              <span class="shop-city__item-shops-count">{{ shops ? shops.length : 0 }}</span>
            </div>
            <svg
              class="shop-city__item-arrow"
              width="11"
              height="12"
              viewBox="0 0 11 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.99998 8.57983C4.82076 8.57983 4.64156 8.50781 4.50493 8.36405L0.205142 3.83815C-0.0683806 3.55025 -0.0683806 3.08346 0.205142 2.79567C0.478554 2.50789 0.921935 2.50789 1.19548 2.79567L4.99998 6.80044L8.80451 2.79581C9.07803 2.50803 9.52137 2.50803 9.79476 2.79581C10.0684 3.0836 10.0684 3.55039 9.79476 3.83829L5.49504 8.36419C5.35834 8.50797 5.17914 8.57983 4.99998 8.57983Z"
                fill="#909090"
              />
            </svg>
          </div>
          <ul class="shop-city__item-body shops-list" v-if="openedCities[city]">
            <li class="shops-list__item" v-for="(shop, idx) in shops" :key="idx">
              <ShopCard :shop-data="shop" />
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <ShopsFilterModal :key="222" />
    <ShopCardModal />
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import VueMap from '@/components/map/VueMap'
import ShopCard from '@/components/shops/ShopCard'
import ShopsFilter from '@/components/shops/ShopsFilter'
import ShopsSlider from '@/components/shops/ShopsSlider'
import ShopsFilterModal from '@/components/shops/ShopsFilterModal'
import ShopCardModal from '@/components/shops/ShopCardModal'
import EventsBlock from '@/components/events/EventsBlock'

export default {
  name: 'Shops',
  components: { VueMap, EventsBlock, ShopCardModal, ShopsFilterModal, ShopsSlider, ShopsFilter, ShopCard },
  data () {
    return {
      openedItems: {},
      filteredShopsList: null,
      selectValue: null,
      openedCities: {}
    }
  },
  computed: {
    ...mapGetters(['shopsByCities']),
    ...mapState({
      language: state => state.translation.language,
      selectedUserLocation: state => state.geoLocation.selectedUserLocation,
      shops: state => state.shops.shops,
      filters: state => state.shops.filters,
      selectedCityOnShops: state => state.shops.selectedCity,
      isShowFiltersModal: state => state.shops.isShowFiltersModal
    }),
    isFiltering () {
      if (Object.values(this.filters).length) {
        return !!(Object.values(this.filters).length > 1 || Object.values(this.filters)[0].length)
      }
      return false
    },
    cityNameByLanguage () {
      return this.language === 'ru' ? this.selectedUserLocation?.['name_ru'] : this.selectedUserLocation?.['name_uk']
    },
    filteredShops () {
      let result = this.shops

      for (let item in this.filters) {
        if (this.filters.hasOwnProperty(item)) {
          if (Array.isArray(this.filters[item])) {
            const arr = []

            this.shops.forEach(shop => {
              if (this.filters[item].every(item => shop.services.map(service => service.key).includes(item))) {
                arr.push(shop)
              }
            })

            result = arr
          } else {
            result = result.filter(shop => shop[item])
          }
        }
      }

      return result
    },
    filteredShopsByCity () {
      return this.filteredShops.filter(shop => shop.cityId === this.selectedCityOnShops.city_id)
    },
    computedShopsByCities () {
      // if (this.shopsByCities) {
      //   return this.shopsByCities
      // }
      if (this.shopsByCities && this.selectedCityOnShops) {
        const cityName = this.selectedCityOnShops.name || this.selectedCityOnShops.short_name
        const cityId = this.selectedCityOnShops.city_id
        const clonedObj = { ...this.shopsByCities }
        delete clonedObj[cityName]

        let currCity
        for (let key in this.shopsByCities) {
          if (this.shopsByCities[key].find(el => el.cityId === cityId)) {
            currCity = {
              [cityName]: this.shopsByCities[key]
            }
          }
        }
        if (currCity) {
          return { ...currCity, ...clonedObj }
        }
        return clonedObj
      }

      return {}
    }
  },
  methods: {
    ...mapActions(['GET_SHOPS', 'SET_SELECTED_CITY_ACTION', 'SET_SHOPS_FILTERS_FROM_URL_ACTION']),
    handleOpen (i) {
      const clone = { ...this.openedItems }
      clone[i] = !this.openedItems[i]
      this.openedItems = clone
    },
    toggleOpenedCity (city) {
      if (!this.openedCities.hasOwnProperty(city)) this.$set(this.openedCities, city, true)
      else this.openedCities[city] = !this.openedCities[city]
    }
  },
  mounted () {
    this.GET_SHOPS()
  },
  created () {
    this.SET_SHOPS_FILTERS_FROM_URL_ACTION()
  },
  watch: {
    selectedUserLocation: {
      immediate: true,
      handler (value) {
        this.SET_SELECTED_CITY_ACTION({ ...value, name: this.cityNameByLanguage })
      }
    }
  }
}
</script>

<style scoped lang="sass">

.shop-city
  margin-top: 25px

  +mmin($tablet--hor)
    margin-top: 50px

.shop-city-page-title
  font-size: 18px
  font-weight: 500
  margin-bottom: 15px

  +mmin($tablet--hor)
    font-size: 24px
    margin-bottom: 40px

.shop-city__header
  display: flex
  flex-flow: row wrap
  justify-content: space-between

.firm-shops__title
  padding: 0
  margin: 0 0 25px
  font-weight: 500
  font-size: 18px

  +mmin($tablet--hor)
    font-size: 24px
    margin: 0 0 50px

.shop-city__list
  +list-unstyled

.shop-city__item
  &:not(:last-child)
    margin-bottom: 15px

    +mmin($tablet--hor)
      margin-bottom: 25px

  &--opened
    .shop-city__item-arrow
      transform: rotate(180deg)

.shops-filtered
  margin-top: 25px

  +mmin($tablet--hor)
    margin-top: 95px

.shop-city__item-header
  display: flex
  justify-content: space-between
  align-items: center
  padding: 10px 20px
  border: 1px solid #E7E7E7
  border-radius: 3px
  margin-bottom: 20px
  cursor: pointer

  +mmin($tablet--hor)
    background: #F8F8F8
    border: none
    padding: 24px 45px

.shop-city__item-shop-name
  display: flex
  align-items: flex-start
  font-size: 18px

.shop-city__item-shops-count
  display: block
  font-size: 14px
  color: $placeholder-color
  margin-top: -5px
  margin-left: 9px

.shops-list
  +list-unstyled

.shops-list__item
  &:not(:last-child)
    margin-bottom: 15px

  +mmin($tablet--hor)
    &:not(:last-child)
      margin-bottom: 20px

.shop-city-toggle-filters-modal
  display: flex
  width: calc(100% - 30px)
  align-items: center
  font-size: 16px
  padding: 13px 20px
  border: 1px solid #E7E7E7
  border-radius: 3px
  background: none
  margin: 0 auto 15px

  +mmin($mid)
    display: none

  svg
    margin-right: 12px

.shop-city-attention
  background: rgba(255, 206, 31, 0.1)
  border: 1px solid #FFCE1F
  border-radius: 3px
  margin: 0 auto 30px
  display: flex
  flex-flow: column
  padding: 20px 20px 30px

  +mmin($tablet)
    width: calc(100% - 30px)
    flex-flow: row nowrap
    align-items: center
    padding: 20px 30px

  +mmin($tablet--hor)
    margin: 0 0 40px
    max-width: 770px

  svg
    flex-shrink: 0
    margin-bottom: 20px
    width: 30px
    height: 30px

    +mmin($tablet)
      width: 24px
      height: 24px
      margin-bottom: 0
      margin-right: 30px

.shop-city-attention__title
  display: block
  font-size: 16px
  font-weight: 500
  margin-bottom: 15px

  +mmin($tablet)
    margin-bottom: 0
    margin-right: 60px

.shop-city-attention__text
  display: block
  font-size: 14px
</style>
